var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "clipper-range"
  }, [_c('div', {
    directives: [{
      name: "stream",
      rawName: "v-stream:mousedown",
      value: _vm.mousedown$,
      expression: "mousedown$",
      arg: "mousedown"
    }, {
      name: "stream",
      rawName: "v-stream:touchstart",
      value: _vm.touchstart$,
      expression: "touchstart$",
      arg: "touchstart"
    }],
    staticClass: "wrap"
  }, [_c('div', {
    staticClass: "stick"
  }), _c('div', {
    staticClass: "bar",
    style: _vm.barStyle
  })])]);
}
var staticRenderFns = []

export { render, staticRenderFns }